import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { DONVIDAOTAO_API } from '@app/utils/apiUrl.js';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { ConfirmModal } from '@app/modules/modal/ConfirmModal';
import { messageToast, objectShowNumber } from '@app/utils/define';
import { createUrlWithParam } from '@app/utils/helper';
import { URI_INTERNAL } from '@app/utils/pathLocations';

const DonViDaoTao = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const deleteFunc = useMutation((value) =>
        DeleteSingle(DONVIDAOTAO_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['donViDaoTaoData', valueSearch, page, pageSize],
        () => {
            const model = {
                Keyword: valueSearch ? valueSearch : '',
                PageIndex: page,
                PageSize: pageSize
            };

            replaceHistory(page, pageSize, valueSearch ? valueSearch : '');
            return Get(DONVIDAOTAO_API.GET_PAGING, null, model);
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.DONVIDAOTAO_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res && (res.status === 200 || res.status === 201)) {
                        refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                        if (
                            data != null &&
                            data.data &&
                            data.data.length === 1 &&
                            page !== 1
                        ) {
                            history.push(
                                createUrlWithParam(URI_INTERNAL.DONVIDAOTAO_PATH, {
                                    page: page - 1,
                                    size: pageSize,
                                    search: search
                                })
                            );
                        }
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: () => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });

            replaceHistory(page, pageSize, search);
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h3 className="card-title">Danh sách đơn vị đào tạo</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <form className="form-inline">
                                    <label htmlFor="showNumber" className="mr-2">
                                        Hiển thị :
                                    </label>
                                    <select
                                        id="showNumber"
                                        className="form-control"
                                        value={pageSize}
                                        onChange={(e) => onChangeShowNumber(e)}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option key={Number(key)} value={item.value}>
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>
                                </form>
                                <NavLink
                                    className="nav-link-reject nav-link"
                                    to={URI_INTERNAL.DONVIDAOTAO_CREATE_PATH}
                                >
                                    <button type="button" className="btn btn-info">
                                        Thêm mới
                                    </button>
                                </NavLink>
                            </div>

                            {isLoading ? (
                                <div>Đang tải...</div>
                            ) : isError ? (
                                <div>Có lỗi xảy ra: {error?.message}</div>
                            ) : (
                                <div className="table-responsive">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>STT</th>
                                                <th>Tên đơn vị đào tạo</th>
                                                <th>Hành động</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data && data.data && data.data.length > 0 ? (
                                                data.data.map((item, index) => (
                                                    <tr key={item.id || item.Id || index}>
                                                        <td>{(page - 1) * pageSize + index + 1}</td>
                                                        <td>
                                                            {item.tenDonViDaoTao ||
                                                                item.TenDonViDaoTao}
                                                        </td>
                                                        <td>
                                                            <NavLink
                                                                className="btn btn-sm btn-primary mr-2"
                                                                to={`${URI_INTERNAL.DONVIDAOTAO_EDIT_PATH}?id=${item.id || item.Id}`}
                                                            >
                                                                Sửa
                                                            </NavLink>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() =>
                                                                    deleteAction(
                                                                        item.id || item.Id,
                                                                        item.tenDonViDaoTao ||
                                                                        item.TenDonViDaoTao ||
                                                                        ''
                                                                    )
                                                                }
                                                            >
                                                                Xóa
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">
                                                        Không có dữ liệu.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                            {data && data.totalRecords > pageSize && (
                                <div className="d-flex justify-content-end mt-3">
                                    <Pagination
                                        activePage={page}
                                        itemsCountPerPage={pageSize}
                                        totalItemsCount={data.totalRecords}
                                        pageRangeDisplayed={5}
                                        onChange={changePage}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="delete"
                handleAccept={() => acceptDelete()}
                handleCancel={() => cancelDelete()}
                content={confirmDelMessage}
            />
        </div>
    );
};

export default DonViDaoTao;
